import axios from 'axios';
import { call, all, put, takeLatest, select } from 'redux-saga/effects';

import * as productWithoutPictureReportActions from './product-without-picture-report-actions';

import { saveAs } from 'file-saver';

import { GET_LIST_ALL_REQUEST, SHARE_CSV } from './product-without-picture-report-constants';

import notification from '~/services/notification';
import productWithoutPictureReportServices from './product-without-picture-report-service';

import { ISA_ERROR } from '~/constants';

import { AppStateType } from '../root-reducer';

import { formatDateTime, formatMessage } from '~/i18n/translate';

let cancel: any;
const CancelToken = axios.CancelToken;

export function* getAllProductWithoutPictureReport({
  type,
  payload
}: {
  type: any;
  payload: {
    queryText?: string;
    hasPictures?: 'without_picture' | 'with_picture';
  };
}) {
  if (cancel !== undefined) cancel();
  const cancelToken = new CancelToken(function executor(c) {
    cancel = c;
  });

  try {
    yield put(productWithoutPictureReportActions.setLoadingData(true));

    const { rowsPerPage, page } = yield select((state: AppStateType) => state.productWithoutPictureReport.list);

    const baseParams = {
      queryString: payload?.queryText ?? '',
      hasPictures: payload?.hasPictures === 'with_picture'
    };

    const [{ data: products }, { data: countData }] = yield all([
      call(
        productWithoutPictureReportServices.getList,
        {
          ...baseParams,
          skip: page === 0 ? 0 : page * rowsPerPage,
          limit: rowsPerPage
        },
        { cancelToken }
      ),
      call(productWithoutPictureReportServices.getListCount, { ...baseParams }, { cancelToken })
    ]);

    yield put(
      productWithoutPictureReportActions.getAllProductWithoutPictureReportsSuccess({
        products: [...(products ?? [])],
        rowsCount: countData?.count ?? 0
      })
    );
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    yield put(productWithoutPictureReportActions.setLoadingData(false));
  }
}

export function* shareCSV({ payload }: any) {
  const toast: any = notification.loading(formatMessage('commonLoadingMessage'));

  try {
    const params = {
      queryString: payload?.queryText ?? '',
      hasPictures: payload?.hasPictures === 'with_picture'
    };

    const data = yield call(productWithoutPictureReportServices.getCSV, params);

    if (params?.hasPictures) {
      saveAs(data?.data, `Relatorio_Produtos_Com_Foto_${formatDateTime(new Date())}.csv`);
    } else {
      saveAs(data?.data, `Relatorio_Produtos_Sem_Foto_${formatDateTime(new Date())}.csv`);
    }
  } catch (error) {
    yield put({ type: ISA_ERROR, error });
  } finally {
    toast.close();
  }
}

export default all([
  takeLatest(GET_LIST_ALL_REQUEST, getAllProductWithoutPictureReport),
  takeLatest(SHARE_CSV, shareCSV)
]);
